import axios from 'axios';
import { ENV } from '@configs/env';

export const refreshToken = async (refreshToken, setAuthState, logout) => {
    try {
        if (!refreshToken) throw new Error('Missing refresh token');

        const bareAPI = axios.create({
            baseURL: ENV.API_URL,
            headers: {
                'x-refresh-token': refreshToken,
                'Content-Type': 'application/json',
            },
        });

        const response = await bareAPI.post('/auth/refresh-token');
        // Handle nested response structure: response.data.data
        const responseData = response.data.data || response.data;
        const { user, accessToken, refreshToken: newRefresh } = responseData;

        setAuthState({
            user: user || null,
            role: user?.role || null,
            permissions: user?.permissions || [],
            isAuthenticated: true,
            accessToken: accessToken,
            refreshToken: newRefresh,
        });

        return { 
            accessToken: accessToken, 
            refreshToken: newRefresh 
        };
    } catch (error) {
        console.error('Refresh token failed:', error.response?.data?.message || error.response?.data?.error || error.message);
        logout();
        return null;
    }
};